import { ImageType } from "../types/productTypes";

export const preloadUrls = async (
   urls: (ImageType | undefined)[] | undefined
) => {
   if (!urls || urls.length === 0) return;

   const preloadPromises = urls.map((image) =>
      image && image.url
         ? new Promise<void>((resolve, reject) => {
              const img = new Image();
              img.crossOrigin = "anonymous";
              img.onload = () => resolve();
              img.onerror = () =>
                 reject(`Failed to preload image: ${image.url}`);
              img.src = image.url;
           })
         : Promise.resolve()
   );

   try {
      await Promise.all(preloadPromises);
   } catch (error) {
      console.error("An error occurred during preloading:", error);
   }
};
